import React from 'react';
import { SummaryBox, HeaderTitle } from '../styles';

interface SurveySummaryBoxProps {
  surveyId: number;
  surveyAverageTime: number;
  totalResults?: number;
  formatTime: (ms: number) => string;
}

const SurveySummaryBox: React.FC<SurveySummaryBoxProps> = ({
  surveyId,
  surveyAverageTime,
  totalResults,
  formatTime,
}) => (
  <SummaryBox>
    <div
      style={{
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
      }}
    >
      <HeaderTitle>
        <p>Survey Time Summary</p>
      </HeaderTitle>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          margin: '20px 0',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <h3>SurveyId</h3>
          <p style={{ fontSize: '24px', fontWeight: 'bold' }}>{surveyId}</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h3>Average Time to Complete Survey</h3>
          <p style={{ fontSize: '24px', fontWeight: 'bold' }}>
            {formatTime(surveyAverageTime)}
          </p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h3>Total Respondents</h3>
          <p style={{ fontSize: '24px', fontWeight: 'bold' }}>
            {totalResults || 0}
          </p>
        </div>
      </div>
    </div>
  </SummaryBox>
);

export default SurveySummaryBox;
